/**
=========================================================
•⁠  ⁠Material Dashboard 2 React - v2.2.0
=========================================================

•⁠  ⁠Product Page: https://www.creative-tim.com/product/material-dashboard-react
•⁠  ⁠Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

•⁠  ⁠The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The ⁠ type ⁠ key with the ⁠ collapse ⁠ value is used for a route.
  2. The ⁠ type ⁠ key with the ⁠ title ⁠ value is used for a title inside the Sidenav. 
  3. The ⁠ type ⁠ key with the ⁠ divider ⁠ value is used for a divider between Sidenav items.
  4. The ⁠ name ⁠ key is used for the name of the route on the Sidenav.
  5. The ⁠ key ⁠ key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The ⁠ icon ⁠ key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The ⁠ collapse ⁠ key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the ⁠ collapse ⁠ key.
  8. The ⁠ route ⁠ key is used to store the route location which is used for the react router.
  9. The ⁠ href ⁠ key is used to store the external links location.
  10. The ⁠ title ⁠ key is only for the item with the type of ⁠ title ⁠ and its used for the title text on the Sidenav.
  10. The ⁠ component ⁠ key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import WelcomeEmpresa from "pages/empresa/welcome-empresa"; 

// Gestión General layouts
import GestionGeneralAdmin from "pages/superadmin/Gestion-general/empresa";
import GestionGeneral from "pages/talento-evaluacion/gestion-general";
import EmpresasRegistradas from "pages/talento-evaluacion/gestion-general/empresas-registradas";
import ReportePruebas from "pages/talento-evaluacion/gestion-general/reporte-pruebas";

// Gestión de Usuarios layouts
import GestionUsuarios from "pages/talento-evaluacion/gestion-usuarios";
import Empresas from "pages/talento-evaluacion/gestion-usuarios/empresas";
import NuevaEmpresa from "pages/talento-evaluacion/gestion-usuarios/nueva-empresa";

// Gestión de Inventario layouts
import GestionInventario from "pages/talento-evaluacion/gestion-inventario";
import TestDisponibles from "pages/talento-evaluacion/gestion-inventario/test-disponibles";
import RegistroActividades from "pages/talento-evaluacion/gestion-inventario/registro-actividades";
// Gestión de Candidatos layouts
import CargarCandidatos from "pages/empresa/gestion-candidato/cargar-candidatos";
import AsignarLicencias from "pages/empresa/gestion-candidato/asignar-licencias";
import ComprarLicencias from "pages/empresa/gestion-licencias/comprar";
import HistorialCompras from "pages/empresa/gestion-licencias/historial";
import ResumenGeneral from "pages/empresa/resumen-general";
import SoporteTecnico from "pages/empresa/soporte-tecnico";
import CandidateDashboard from "layouts/candidate-test";
import GestionMinoristas from "pages/distribuidor/gestion-minoristas"; // Importar el nuevo componente

//Reporte y Auditorias
import Historicos from "pages/superadmin/reporte-auditoria/historial-actividades"

// Informe Test layout
import InformeTest from "layouts/informe-test";

// Admin Video Panel layout
import AdminVideoPanel from "layouts/admin-video-panel";
import SeleccionarMinorista from "pages/distribuidor/gestion-minoristas/gestion-minoristas-pasos"; // Corregir la ruta de importación
import Planes from "pages/distribuidor/gestion-minoristas/gestion-planes-minorista"; // Importar el nuevo componente Planes

// Route Protection Components
import ProtectedRoute from "components/routes_protection/ProtectedRoute";
import PublicRoute from "components/routes_protection/PublicRoute";
import RoleBasedRoute from "components/routes_protection/RoleBasedRoute";

// Gestión Permisos layout
import GestionPermisos from "pages/superadmin/gestion-usuarios/permisos";

// @mui icons
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";

import {
  DashboardDistribuidor,
  PlanesDistribuidor,
  VerCatalogo,
  CompraLicencias,
  CrearEmpresa,
  AsignarLicenciasEmpresa,
  CrearMinorista,
  AsignarLicenciasMinorista,
  ReportePaquetes,
  ReporteCreditos,
  GananciaTotal,
  SoporteDistribuidor,
} from "pages/distribuidor/distribuidorAutorizado";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <RoleBasedRoute allowedRoles={['admin', 'evaluador', 'candidato']} redirectTo="/welcome-empresa"><Dashboard /></RoleBasedRoute>,
  },
  {
    key: "candidate-test",
    route: "/candidate-test",
    component: <ProtectedRoute><CandidateDashboard /> </ProtectedRoute>,
  },
  {
    type: "collapse",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Billing",
    key: "billing",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/billing",
    component: <Billing />,
  },
  {
    type: "collapse",
    name: "Gestión General",
    key: "gestion-general",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/gestion-general",
    component: <RoleBasedRoute allowedRoles={['admin', 'manager']}><GestionGeneral /></RoleBasedRoute>,
    collapse: [
      {
        name: "Empresas Registradas",
        key: "empresas-registradas",
        route: "/gestion-general/empresas-registradas",
        component: <RoleBasedRoute allowedRoles={['admin', 'manager']}><EmpresasRegistradas /></RoleBasedRoute>,
      },
      {
        name: "Reporte de Pruebas",
        key: "reporte-pruebas",
        route: "/gestion-general/reporte-pruebas",
        component: <RoleBasedRoute allowedRoles={['admin', 'manager']}><ReportePruebas /></RoleBasedRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "Gestión de Usuarios",
    key: "gestion-usuarios",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/gestion-usuarios",
    component: <GestionUsuarios />,
    collapse: [
      {
        name: "Empresas",
        key: "empresas",
        route: "/gestion-usuarios/empresas",
        component: <Empresas />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Gestión de Inventario",
    key: "gestion-inventario",
    icon: <Icon fontSize="small">inventory</Icon>,
    route: "/gestion-inventario",
    component: <GestionInventario />,
    collapse: [
      {
        name: "Test Disponibles",
        key: "test-disponibles",
        route: "/gestion-inventario/test-disponibles",
        component: <TestDisponibles />,
      },
      {
        name: "Registro de Actividades",
        key: "registro-actividades",
        route: "/gestion-inventario/registro-actividades",
        component: <RegistroActividades />,
      },
    
    ],
  },
  // RUTAS PARA EL MÓDULO EMPRESA
  {
  type: "collapse",
  name: "Gestión de Candidatos",
  key: "gestion-candidatos",
  icon: <Icon fontSize="small">group_add</Icon>,
  route: "/gestion-candidato",
  component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>, 
  collapse: [
    {
      name: "Cargar Candidatos",
      key: "cargar-candidatos",
      route: "/gestion-candidato/cargar-candidatos",
      component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><CargarCandidatos /></RoleBasedRoute>,
    },
    {
      name: "Asignar Licencias",
      key: "asignar-licencias",
      route: "/gestion-candidato/asignar-licencias",
      component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><AsignarLicencias /></RoleBasedRoute>,
    },
    {
      name: "Informes",
      key: "informes",
      route: "/informe-test",
      component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><InformeTest /></RoleBasedRoute>,
    },
    ],
  },
  {
  type: "collapse",
  name: "Gestión de Licencias",
  key: "gestion-licencias",
  icon: <Icon fontSize="small">shopping_cart</Icon>,
  route: "/gestion-licencias",
  component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>,
  collapse: [
    {
      name: "Comprar licencias",
      key: "comprar-licencias",
      route: "/gestion-licencias/comprar",
      component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><ComprarLicencias /></RoleBasedRoute>,
    },
    {
      name: "Historial de compras",
      key: "historial-compras",
      route: "/gestion-licencias/historial",
      component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><HistorialCompras /></RoleBasedRoute>,
    },
  ],
},
{
  type: "collapse",
  name: "Resumen General",
  key: "resumen-general",
  icon: <Icon fontSize="small">assessment</Icon>,
  route: "/resumen-general",
  component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><ResumenGeneral /></RoleBasedRoute>,
},
{
  type: "collapse",
  name: "Soporte Técnico",
  key: "soporte-tecnico",
  icon: <Icon fontSize="small">help_outline</Icon>,
  route: "/soporte-tecnico",
  component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><SoporteTecnico /></RoleBasedRoute>,
},
  // Gestión General - Superadmin
     {
    type: "collapse",
    name: "Gestión General",
    key: "gestion-general",
    icon: <Icon fontSize="small">business</Icon>,
    route: "/gestion-general",
    component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>, 
    collapse: [
      {
        name: "Empresa",
        key: "gestion-empresas",
        route: "/gestion-candidato/empresas",
        component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><GestionGeneralAdmin /></RoleBasedRoute>,
      },
    ],
  },
  // Gestion Inventario - Superadmin
       {
    type: "collapse",
    name: "Gestión Inventario",
    key: "gestion-inventario",
    icon: <Icon fontSize="small">inventory_2</Icon>,
    route: "/gestion-inventario",
    component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>, 
    collapse: [
      {
        name: "Test Disponibles",
        key: "test-disponibles",
        route: "/gestion-candidato/test-disponibles",
        component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><GestionGeneralAdmin /></RoleBasedRoute>,
      },
            {
        name: "Configuracion de Licencias",
        key: "Configuracion-licencias",
        route: "/gestion-candidato/config-licencias",
        component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><GestionGeneralAdmin /></RoleBasedRoute>,
      },
    ],
  },
       {
    // Gestion Roles & Permisos - Superadmin
      type: "collapse",
      name: "Gestión Roles & Permisos",
      key: "gestion-roles-permisos",
      icon: <Icon fontSize="small">security</Icon>,
      route: "/gestion-roles-permisos",
      component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>,
      collapse: [
        {
          name: "Permisos",
          key: "gestion-permisos",
          route: "/gestion-permisos",
          component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><GestionPermisos /></RoleBasedRoute>,
        },
      ],
       },
  // Reporte y Auditoria - Superadmin
       {
    type: "collapse",
    name: "Reporte y Auditoria",
    key: "Reporte-Auditoria",
    icon: <Icon fontSize="small">fact_check</Icon>,
    route: "/gestion-inventario",
    component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>, 
    collapse: [
      {
        name: "Historial de Actividades",
        key: "historial-actividades",
        route: "/gestion-candidato/historial-actividades",
        component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><Historicos /></RoleBasedRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "Gestión-Videos", // Nuevo elemento de menú principal
    key: "gestion-videos",
    icon: <Icon fontSize="small">videocam</Icon>, // Puedes cambiar el icono si lo deseas
    route: "/gestion-videos", // Ruta base para el menú principal
    component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}> <MDBox> </MDBox> </RoleBasedRoute>,
    collapse: [
      {
        name: "Videos", // Sub-elemento del menú
        key: "admin-video-panel",
        route: "/gestion-videos/admin-video-panel", // Ruta para el componente AdminVideoPanel
        component: <RoleBasedRoute allowedRoles={['admin', 'empresa']}><AdminVideoPanel /></RoleBasedRoute>,
      },
    ],
  },
  {
    type: "collapse",
    name: "Gestión Minoristas", // Nuevo elemento de menú principal
    key: "gestion-minoristas",
    icon: <Icon fontSize="small">group</Icon>, // Puedes cambiar el icono si lo deseas
    route: "/gestion-minoristas",
    // Ya no tiene un componente directo, ahora tiene un 'collapse'
    collapse: [
      {
        name: "Seleccionar Minorista", // Sub-elemento del menú
        key: "seleccionar-minorista",
        route: "/gestion-minoristas/seleccionar-minorista",
        component: <SeleccionarMinorista />,
      },
      // Si el formulario original de "Distribuidor Autorizado" también necesita estar en el menú,
      // lo añadiríamos aquí como otra sub-opción. Por ahora, solo se añadió la tabla.
      {
        name: "Registrar Distribuidor", // Sub-elemento del menú para el formulario original
        key: "registrar-distribuidor",
        route: "/gestion-minoristas",
        component: <GestionMinoristas />,
      },
      {
        name: "Planes de Tests", // Nuevo sub-elemento para Planes
        key: "planes-tests",
        route: "/gestion-minoristas/planes",
        component: <Planes />,
      },
    ],
  },
  // CONFIGURACIÓN ACTUALIZADA DEL DISTRIBUIDOR AUTORIZADO
  {
    type: "collapse",
    name: "Dashboard General",
    key: "distribuidor-dashboard-general",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/distribuidor-autorizado/dashboard",
    component: <RoleBasedRoute allowedRoles={['evaluador']}><DashboardDistribuidor /></RoleBasedRoute>,
  },
  // Gestión de empresas - CON SUBMENÚS
  {
  type: "collapse",
  name: "Gestión de empresas",
  key: "distribuidor-gestion-empresas",
  icon: <Icon fontSize="small">business</Icon>,
  route: "/distribuidor-autorizado/empresas",
  component: <RoleBasedRoute allowedRoles={['evaluador']}> <MDBox> </MDBox> </RoleBasedRoute>,
  collapse: [
    {
      name: "Asignar licencias",
      key: "distribuidor-asignar-licencias-empresas",
      route: "/distribuidor-autorizado/empresas/asignar",
      component: <RoleBasedRoute allowedRoles={['evaluador']}><AsignarLicenciasEmpresa /></RoleBasedRoute>,
    },
    {
      name: "Crear empresa",
      key: "distribuidor-crear-empresa",
      route: "/distribuidor-autorizado/empresas/crear",
      component: <RoleBasedRoute allowedRoles={['evaluador']}><CrearEmpresa /></RoleBasedRoute>,
    },
  ],
  },
  // Gestión de minoristas - CON SUBMENÚS
  {
  type: "collapse",
  name: "Gestión de minoristas",
  key: "distribuidor-gestion-minoristas",
  icon: <Icon fontSize="small">people</Icon>,
  route: "/distribuidor-autorizado/minoristas",
  component: <RoleBasedRoute allowedRoles={['evaluador']}> <MDBox> </MDBox> </RoleBasedRoute>,
  collapse: [
    {
      name: "Asignar licencias",
      key: "distribuidor-asignar-licencias-minoristas",
      route: "/distribuidor-autorizado/minoristas/asignar",
      component: <RoleBasedRoute allowedRoles={['evaluador']}><AsignarLicenciasMinorista /></RoleBasedRoute>,
    },
    {
      name: "Crear minorista",
      key: "distribuidor-crear-minorista",
      route: "/distribuidor-autorizado/minoristas/crear",
      component: <RoleBasedRoute allowedRoles={['evaluador']}><CrearMinorista /></RoleBasedRoute>,
    },
  ],
  },
  {
  type: "collapse",
  name: "Compra de Licencias",
  key: "distribuidor-compra-licencias",
  icon: <Icon fontSize="small">shopping_cart</Icon>,
  route: "/distribuidor-autorizado/compra-licencias",
  component: <RoleBasedRoute allowedRoles={['evaluador']}><CompraLicencias /></RoleBasedRoute>,
  },
  {
    type: "collapse",
    name: "Soporte Técnico",
    key: "distribuidor-soporte-tecnico",
    icon: <Icon fontSize="small">help</Icon>,
    route: "/distribuidor-autorizado/soporte",
    component: <RoleBasedRoute allowedRoles={['evaluador']}><SoporteDistribuidor /></RoleBasedRoute>,
  },
  // FIN DE CONFIGURACIÓN DEL DISTRIBUIDOR AUTORIZADO
  {
    type: "collapse",
    name: "RTL",
    key: "rtl",
    icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
    route: "/rtl",
    component: <RTL />,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/profile",
    component: <RoleBasedRoute allowedRoles={['admin', 'evaluador', 'candidato']}><Profile /></RoleBasedRoute>,
  },

  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <PublicRoute redirectIfAuthenticated={true} customRedirectPath="/dashboard"><SignIn /></PublicRoute>,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <PublicRoute redirectIfAuthenticated={true} customRedirectPath="/dashboard"><SignUp /></PublicRoute>,
  },
  // Rutas ocultas (no aparecen en sidebar pero son accesibles)
  {
    key: "nueva-empresa",
    route: "/gestion-usuarios/nueva-empresa",
    component: <NuevaEmpresa />,
  },
  {
    key: "welcome-empresa",
    route: "/welcome-empresa",
    component: <ProtectedRoute><RoleBasedRoute allowedRoles={['empresa']}><WelcomeEmpresa /></RoleBasedRoute></ProtectedRoute>,
  },
];

export default routes;

